import { useEffect, useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Footer } from '../../components/footer';
import { Navbar } from '../../components/navbar';
import AppConfig from '../../utils/appconfig';
import { scrollBodyToTop } from '../../utils/utils';
import { SectionTitle } from '../../components/sectionTitle';
import ProductsList from './components/ProductsList';
import ProductModal from './components/ProductModal';
import CartDrawer from './components/CartDrawer';
import CheckoutModal from './components/CheckoutModal';
import Toast from './components/Toast';
import { AuthProvider } from '../../context/AuthContext';
import { useCart } from '../../hooks/useCart';
import { Product } from '../../lib/store/products';

const currentPage: string = 'hard-adv-store';

// Osobny QueryClient dla sklepu — reszta strony nie korzysta z React
// Query.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function HardAdvStoreContent() {
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [isCheckoutOpen, setIsCheckoutOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState<string | null>(null);
  const { data: cart } = useCart();

  useEffect(() => {
    document.title = `Hard Adv Store - ${AppConfig.baseTabTitle}`;
    scrollBodyToTop();
  }, []);

  return (
    <div className="App theme-light">
      <Navbar
        currentPage={currentPage}
        onCartClick={() => setIsCartOpen(true)}
        cartItemCount={cart?.item_count || 0}
      />

      <div className="content-wrapper hard-adv-store__content-wrapper">
        <div className="hard-adv-store__header">
          <SectionTitle
            title={
              <>
                Hard Adv <span className="text-color--primary">Store</span>
              </>
            }
            customClassName="section-title__wrapper--home"
          />
        </div>

        <ProductsList onProductClick={setSelectedProduct} />
      </div>

      <ProductModal
        product={selectedProduct}
        onClose={() => setSelectedProduct(null)}
        onAddedToCart={(message) => setToastMessage(message)}
      />

      <Toast message={toastMessage} onClose={() => setToastMessage(null)} />

      <CartDrawer
        isOpen={isCartOpen}
        onClose={() => setIsCartOpen(false)}
        onToast={(message) => setToastMessage(message)}
        onCheckoutClick={() => {
          setIsCartOpen(false);
          setIsCheckoutOpen(true);
        }}
      />

      <CheckoutModal isOpen={isCheckoutOpen} onClose={() => setIsCheckoutOpen(false)} />

      <Footer currentPage={currentPage} />
    </div>
  );
}

export function HardAdvStore() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <HardAdvStoreContent />
      </AuthProvider>
    </QueryClientProvider>
  );
}
